import { EOrderStatus } from "../types/order/order";


export class EnumTranslator {

  public static StatusEnumToString = (status: EOrderStatus): string => {
    switch (status) {
      case EOrderStatus.AwaitingPayment:
        return "In fase di verifica";
      case EOrderStatus.Processing:
        return "In elaborazione";
      case EOrderStatus.Shipped:
        return "Spedito";
      case EOrderStatus.Delivered:
        return "Consegnato";
      default:
        return "In fase di verifica";
    }
  };

  public static LanguageEnumToString = (language: number): string => {
    switch (language) {
      case 0:
        return "it";
      case 1:
        return "en";
      default:
        return "it";
    }
  };


  /*public static ProductAvailabilityEnumToString = (availability: number) : string => {
        switch(availability){
            case 0:
                return Languages.languages.FilterAvailable1;
            case 1:
                return Languages.languages.FilterAvailable2;
            case 2:
                return Languages.languages.FilterAvailable3;
            case 3:
                return Languages.languages.FilterAvailable4;
            default: 
            return Languages.languages.FilterAvailable1;
        }
    }
*/
  // order
  public static ShippingStringCleaner = (shippingString: string) => {
    var cleanedShippingString = shippingString.replace("}", ", ").replace("[", ", ").replace("]", " ").replace(")", ") ");
    return cleanedShippingString;
  };


}
